var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandmark = function SvgLandmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4v2h3v2H8v-2h3v-2H7a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zM8 4v12h8V4z"
  })));
};
export default SvgLandmark;